import type { TFunction } from '../../i18n/I18nProvider';
import type { ClientFlag } from '../../ui';
import type { TrainerClient } from '../../api/types';

/** Oznake klijenta: propušteni treninzi, nema mjera, nepročitane poruke. */
export function clientFlags(client: TrainerClient, t: TFunction): ClientFlag[] {
  const flags: ClientFlag[] = [];
  if (client.missedWorkouts > 0) {
    flags.push({ label: t('trainer.flagMissed', { n: client.missedWorkouts }), tone: 'warning' });
  }
  if (!client.hasMeasurements) {
    flags.push({ label: t('trainer.flagNoMeasurements'), tone: 'neutral' });
  }
  if (client.unreadMessages > 0) {
    flags.push({ label: t('trainer.flagUnread'), tone: 'accent' });
  }
  return flags;
}
